import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import DeviceItem, { DeviceItemCount } from '../models/data/DeviceItem';
import DeviceItemRequest from '../models/requests/GetDeviceItem';

// 機器点検実績情報の取得関数
export default function requestDeviceItemList(
  url: string,
  params?: DeviceItemRequest,
): Promise<AxiosResponse<DeviceItem[]>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceItem[]>(url, config);
}

// 機器点検実績情報件数の取得関数
export function requestCountDeviceItem(
  url: string,
  params?: DeviceItemRequest,
): Promise<AxiosResponse<DeviceItemCount>> {
  const config = createRequestConfig({ params });
  return axios.get<DeviceItemCount>(url, config);
}
